import React, { type SyntheticEvent } from 'react';
import { styled } from '@compiled/react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import Button from '@atlaskit/button';
import CheckIcon from '@atlaskit/icon/core/migration/check-mark--check';
import CrossIcon from '@atlaskit/icon/core/migration/cross';

import { token } from '@atlaskit/tokens';

import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

export type Props = {
	isConfirmDisabled: boolean;
	onCancel: (arg1: UIAnalyticsEvent) => void;
	onConfirm: (arg1: UIAnalyticsEvent) => void;
};

export const ActionButtons = (props: Props) => {
	const { formatMessage } = useIntl();

	const handleCancel = (event: SyntheticEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => {
		props.onCancel(analyticsEvent);
	};

	const handleConfirm = (event: SyntheticEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => {
		props.onConfirm(analyticsEvent);
	};

	return (
		<Wrapper>
			<ButtonWrapper>
				<Button
					isDisabled={props.isConfirmDisabled}
					onClick={handleConfirm}
					iconBefore={<CheckIcon label={formatMessage(messages.confirm)} LEGACY_size="small" />}
					testId="issue-field-service-entity.common.ui.collapsible-field.edit.action-buttons.confirm"
					interactionName="auto-generated.issue-field-service-entity.common.ui.collapsible-field.edit.action-buttons.confirm.button"
				/>
			</ButtonWrapper>
			<ButtonWrapper>
				<Button
					onClick={handleCancel}
					iconBefore={<CrossIcon label={formatMessage(messages.cancel)} LEGACY_size="small" />}
					testId="issue-field-service-entity.common.ui.collapsible-field.edit.action-buttons.cancel"
					interactionName="auto-generated.issue-field-service-entity.common.ui.collapsible-field.edit.action-buttons.cancel.button1"
				/>
			</ButtonWrapper>
		</Wrapper>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.div({
	display: 'flex',
	marginTop: 0,
	marginBottom: 0,
	marginLeft: token('space.negative.025'),
	marginRight: token('space.negative.025'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ButtonWrapper = styled.div({
	boxShadow: token('elevation.shadow.raised'),
	backgroundColor: token('elevation.surface'),
	marginTop: token('space.025'),
	marginRight: token('space.025'),
	marginBottom: token('space.025'),
	marginLeft: token('space.025'),
	// eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
	borderRadius: token('radius.small', '3px'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'& button': {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: '32px',
		height: '32px',
	},
});
